import { HighlightPost } from "@lib/models";
import React, { Component } from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { GlobalSpinner } from "../globalSpinner";
import NoData from "../shared/NoData";
import { LazyLoadImage } from 'react-lazy-load-image-component';


type Props = {
  data?: HighlightPost[]
  isLoading: boolean,
} & WithTranslation

const KEY_STORAGE_LANG = "lang";
const LANG_VN = "vn";

class HighlightRelatedArticles extends Component<Props> {
  render(): React.ReactNode {
    return (
      <>
        <div className="flex items-center justify-between h-10 mt-1 mb-2">
          <div className="flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className="fill-primary-lighter dark:fill-black"
            >
              <path d="M19 4.99998H9C8.5925 4.94184 8.17705 4.97935 7.78656 5.10955C7.39606 5.23976 7.04123 5.45907 6.75017 5.75014C6.4591 6.04121 6.23978 6.39604 6.10958 6.78653C5.97938 7.17703 5.94186 7.59247 6 7.99998V18C6 18.5304 5.78929 19.0391 5.41422 19.4142C5.03914 19.7893 4.53044 20 4 20H19C19.4075 20.0581 19.823 20.0206 20.2134 19.8904C20.6039 19.7602 20.9588 19.5409 21.2498 19.2498C21.5409 18.9587 21.7602 18.6039 21.8904 18.2134C22.0206 17.8229 22.0581 17.4075 22 17V7.99998C22.0581 7.59247 22.0206 7.17703 21.8904 6.78653C21.7602 6.39604 21.5409 6.04121 21.2498 5.75014C20.9588 5.45907 20.6039 5.23976 20.2134 5.10955C19.823 4.97935 19.4075 4.94184 19 4.99998ZM14 15.577C14.0179 15.7024 14.0063 15.8302 13.9663 15.9503C13.9262 16.0704 13.8587 16.1796 13.7692 16.2691C13.6796 16.3587 13.5705 16.4262 13.4503 16.4662C13.3302 16.5063 13.2024 16.5179 13.077 16.5H9.923C9.79763 16.5179 9.66982 16.5063 9.54968 16.4662C9.42955 16.4262 9.32038 16.3587 9.23084 16.2691C9.14129 16.1796 9.07381 16.0704 9.03375 15.9503C8.99368 15.8302 8.98213 15.7024 9 15.577V13.423C8.98213 13.2976 8.99368 13.1698 9.03375 13.0497C9.07381 12.9295 9.14129 12.8204 9.23084 12.7308C9.32038 12.6413 9.42955 12.5738 9.54968 12.5337C9.66982 12.4937 9.79763 12.4821 9.923 12.5H13.077C13.2024 12.4821 13.3302 12.4937 13.4503 12.5337C13.5705 12.5738 13.6796 12.6413 13.7692 12.7308C13.8587 12.8204 13.9262 12.9295 13.9663 13.0497C14.0063 13.1698 14.0179 13.2976 14 13.423V15.577ZM19 16.75H17C16.8011 16.75 16.6103 16.671 16.4697 16.5303C16.329 16.3897 16.25 16.1989 16.25 16C16.25 15.8011 16.329 15.6103 16.4697 15.4696C16.6103 15.329 16.8011 15.25 17 15.25H19C19.1989 15.25 19.3897 15.329 19.5303 15.4696C19.671 15.6103 19.75 15.8011 19.75 16C19.75 16.1989 19.671 16.3897 19.5303 16.5303C19.3897 16.671 19.1989 16.75 19 16.75ZM19 13.75H17C16.8011 13.75 16.6103 13.671 16.4697 13.5303C16.329 13.3897 16.25 13.1989 16.25 13C16.25 12.8011 16.329 12.6103 16.4697 12.4696C16.6103 12.329 16.8011 12.25 17 12.25H19C19.1989 12.25 19.3897 12.329 19.5303 12.4696C19.671 12.6103 19.75 12.8011 19.75 13C19.75 13.1989 19.671 13.3897 19.5303 13.5303C19.3897 13.671 19.1989 13.75 19 13.75ZM19 9.74998H9.75C9.55109 9.74998 9.36032 9.67096 9.21967 9.53031C9.07902 9.38966 9 9.19889 9 8.99998C9 8.80107 9.07902 8.6103 9.21967 8.46965C9.36032 8.329 9.55109 8.24998 9.75 8.24998H19C19.1989 8.24998 19.3897 8.329 19.5303 8.46965C19.671 8.6103 19.75 8.80107 19.75 8.99998C19.75 9.19889 19.671 9.38966 19.5303 9.53031C19.3897 9.67096 19.1989 9.74998 19 9.74998ZM3.251 18.5C3.08664 18.5002 2.92385 18.4681 2.77195 18.4053C2.62006 18.3425 2.48204 18.2504 2.36582 18.1342C2.24961 18.0179 2.15747 17.8799 2.09469 17.728C2.03192 17.5761 1.99974 17.4133 2 17.249V11C2.00158 10.47 2.21281 9.96224 2.58754 9.58751C2.96227 9.21278 3.47006 9.00156 4 8.99998H4.5V17.249C4.50013 17.4131 4.46793 17.5757 4.40523 17.7274C4.34254 17.8791 4.25057 18.017 4.13459 18.1332C4.01861 18.2493 3.88089 18.3415 3.72928 18.4044C3.57767 18.4674 3.41515 18.4998 3.251 18.5Z" />
            </svg>
            <span className="pl-2 font-bold text-lg  text-primary-lighter dark:text-black">
              {this.props.t("Related Highlights")}
            </span>
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            className="hidden fill-primary-lighter dark:fill-black"
          >
            <path d="M9.00003 20C8.80228 19.9999 8.60898 19.9413 8.44457 19.8314C8.28016 19.7215 8.15202 19.5653 8.07635 19.3826C8.00068 19.1999 7.98088 18.9989 8.01945 18.8049C8.05802 18.611 8.15322 18.4328 8.29303 18.293L14.586 12L8.29303 5.70698C8.11087 5.51838 8.01008 5.26578 8.01236 5.00358C8.01464 4.74138 8.1198 4.49057 8.30521 4.30516C8.49062 4.11975 8.74143 4.01458 9.00363 4.01231C9.26583 4.01003 9.51843 4.11082 9.70703 4.29298L16.707 11.293C16.8945 11.4805 16.9998 11.7348 16.9998 12C16.9998 12.2651 16.8945 12.5195 16.707 12.707L9.70703 19.707C9.51954 19.8945 9.26523 19.9999 9.00003 20Z" />
          </svg>
        </div>
        <hr className="border-primary-darker dark:border-zinc-200  mb-5 dark:border-zinc-200" />
        {this.props.isLoading ? (
          <GlobalSpinner />
        ) : this.props.data && this.props.data.length === 0 ? (
          <NoData text="There are no Related Highlights" />
        ) : (
          this.props.data && this.props.data.map((item: any, index: number) => (
            <div key={`NEWS_SPORT:${index}`} className="mb-5 max-w-[300px] m-auto" >
              <Link className="mb-3 rounded-lg overflow-hidden block" to={`/highlights/detail/${localStorage.getItem(KEY_STORAGE_LANG) || 'en'}/${item.Slug}`}>
                <div className="highlight-related w-full h-[140px] relative">
                <LazyLoadImage
                  effect="blur"
                  src={(localStorage.getItem(KEY_STORAGE_LANG) === LANG_VN ? LANG_VN : "en") === LANG_VN && !!item.ImageUrl.split(", ")[2] ? item.ImageUrl.split(", ")[2] : item.ImageUrl}
                  alt={item.Title}
                  className="w-full h-full bg-[linear-gradient(180deg,hsla(0,0%,4%,0),#111)]"
                />
                {(localStorage.getItem(KEY_STORAGE_LANG) === LANG_VN ? LANG_VN : "en") === LANG_VN && (
                 <div
                 style={{
                   transform: "translate(-50%, -50%)",
                 }}
                 className="flex absolute top-1/3 left-1/2"
               >
                 <LazyLoadImage
                   effect="blur"
                   src={item.ImageUrl.split(", ")[0]}
                   alt={item.Title}
                   className="object-contain rounded-xl h-full p-2"
                 />
                 <LazyLoadImage
                   effect="blur"
                   src={item.ImageUrl.split(", ")[1]}
                   alt={item.Title}
                   className="object-contain rounded-xl h-full p-2"
                 />
               </div>
                )}
                  <div className="bg-[linear-gradient(180deg,hsla(0,0%,4%,0),#111)] py-0.5 px-2.5 absolute bottom-0 pb-1.5">
                    <span className="ellipse-content text-primary-lighter  font-bold" 
                      dangerouslySetInnerHTML={{
                          __html: item.Title,
                    }} />
                  </div>
                </div>
              </Link>
            </div>
          ))
        )}
      </>
    );
  }
}

export default withTranslation()(HighlightRelatedArticles);